import { ChildAppReactComponent } from "@mondora/microfrontends";
import styled from "styled-components";

// Style and position the embedded iframe
export const ChildApp = styled(ChildAppReactComponent)`
    border: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
`;